import { useEffect, useState } from "react";
import { Card, Image, Table } from "antd";
import axios from "axios";
import Statistic from "antd/es/statistic/Statistic";
import { ShoppingCartOutlined } from "@ant-design/icons";
import { MAIN_URL } from "../../Constants";

const Zaxira = () => {
    let [variations, setVariations] = useState([])
    useEffect(() => {
        axios.get('/variations').then(res => {
            setVariations(res.data)
        })
    }, [])
   
    let columns = [
        {
            title: 'Rasm',
            dataIndex: 'img',
            key: 'img',
            width: 100,
            render: (img) => <Image width={50} height={50} style={{objectFit: 'cover', borderRadius: '5px', border: '1px solid #ccc'}} src={MAIN_URL+ '/' + img} />,
        },
        {
            title: 'Maxsulot nomi',
            dataIndex: 'product',
            key: 'product',
            render: (_, record) => <div><b>{record.sku}</b> <h3>{record.product}</h3> <p>{record.brand} | {record.model}</p> </div>
        },
        {
            title: 'Qoldiq',
            dataIndex: 'count',
            key: 'count',
            render: (count, rec) => count + ' ' + (rec.unit ?? 'birlik')
        },
        {
            title: 'Narxi',
            dataIndex: 'in_uzs',
            key: 'in_uzs',
            render: (price, rec) => <>
            <h4>{Number(price ?? 0).toLocaleString('ru-RU')} so`m</h4>
            <h4>{Number(rec?.in_usd ?? 0).toLocaleString('ru-RU')} $</h4>
            </>
        },
        {
            title: 'Summasi',
            dataIndex: 'in_uzs',
            key: 'summa',
            render: (price, rec) => <h4>{(Number(price ?? 0) * Number(rec?.count ?? 0)).toLocaleString('ru-RU')} so`m</h4>
        },
        {
            title: 'Parametrlar',
            dataIndex: 'description',
            key: 'description',
            render: (description, rec) => <div>
                <p>{rec.country}</p>
                <p>{rec.manufacturer}</p>
                <p>{rec.color}</p>
            </div>
        },
        {
            title: 'Maxsus belgilar',
            dataIndex: 'newto',
            key: 'newto',
            render: (newto, rec) => <div style={{display: 'flex', gap: '5px'}}>
                <p style={{backgroundColor: rec.b_u ? 'green' : 'gray', color: 'white', padding: '5px', borderRadius: '5px'}}>{rec.b_u ? 'B.U' : 'Yangi'}</p>
                <p style={{backgroundColor: rec.quality ? 'blue' : rec.quality === '2' ? 'orange' : 'gray', color: 'white', padding: '5px', borderRadius: '5px'}}>{rec.quality ? 'Original' : rec.quality === '2' ? 'Middle' : 'China'}</p>
            </div>
        },
    ]
    return (
        <>
            <h2>Skлад</h2>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                <Card style={{backgroundColor: '#f2fff4'}}>
                    <Statistic groupSeparator=' ' valueStyle={{ color: 'green' }} title="Qoldiq" value={variations.reduce((a, b) => a + b.count, 0)} suffix="birlik" prefix={<ShoppingCartOutlined />} />
                </Card>
                <Card style={{backgroundColor: '#fffdd0'}}>
                    <Statistic groupSeparator=' ' valueStyle={{ color: 'red' }} title="Kirim Summasi so'mda" value={variations.reduce((a, b) => a + (b.in_uzs * b.count), 0)} suffix="so'm" precision={0} prefix={<ShoppingCartOutlined />} />
                </Card>
                <Card style={{backgroundColor: '#d0d9ff'}}>
                    <Statistic groupSeparator=' ' valueStyle={{ color: 'blue' }} title="Kirim Summasi dollarda" value={variations.reduce((a, b) => a + (b.in_usd * b.count), 0)} suffix="$" precision={0} prefix={<ShoppingCartOutlined />} />
                </Card>
            </div>
            <Table bordered size="small" rowKey="id" columns={columns} dataSource={variations} />
        </>
    )
}

export default Zaxira;
